import React, { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";
import { SearchOutlined } from "@mui/icons-material";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import DataTable from "react-data-table-component";
import { ChevronDown } from "react-feather";
import toast from "react-hot-toast";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import axios from "../../API/axios";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import BlockSharpIcon from "@mui/icons-material/BlockSharp";
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import { ShimmerDiv } from "shimmer-effects-react";
import error from "../../assets/images/Not-Found.png";
import moment from "moment";


const JobList = () => {
	const sessionId = localStorage.getItem("sessionId");
	const [isLoading, setIsLoading] = useState(true);
	const UserType = localStorage.getItem("userType");

	const [isError, setIsError] = useState(false);
	const [unAuthorizeError, setUnAuthorizeError] = useState("");

	// ..................................CloneFolder Start..................................
	const [cloneId, setCloneId] = useState("");
	const [showCloneFolder, setShowCloneFolder] = useState(false);
	const handleCloneFolderClose = () => {
		setShowCloneFolder(false);
	};

	const CloneFolder = async () => {
		const body = {
			sessionId: sessionId,
			jobId: cloneId,
		};
		try {
			const response = await axios.post("/JobAction/CloneJob", body);
			toast.success(response.data.message);
			getAlljobList();

			handleCloneFolderClose();
		} catch (error) {
			console.error("Error deleting account:", error);
			toast.error(error.response.data.message);
		}
	};
	// ..................................CloneFolder End...................................
	//................................. Delete job Start................................. //

	const [jobid, setJobId] = useState(false);

	const [showModal, setShowModal] = useState(false);
	const handleCloseModal = () => setShowModal(false);
	const handleShowModal = () => setShowModal(true);

	const DeleteJob = async () => {
		const responsedata = {
			sessionId: sessionId,
			jobId: jobid,
		};
		console.log("job id", jobid);

		try {
			await axios
				.delete("/JobAction/DeleteJob", {
					data: responsedata,
				})
				.then((resData) => {
					toast.success(resData.data.message);
					setjobList((prevJobs) => prevJobs.filter((job) => job.jobId !== jobid));
					setShowModal(false);
					getAlljobList();
				});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.error(e.response.data.message);

				setShowModal(false);
			} else {
				toast.error(e.response.data.message);
			}
		}
	};

	const handleConfirmDelete = () => {
		DeleteJob();
		setShowModal(false);
	};

	//.................................. Delete job End  ................................... //

	//.................................. Enable Job End  ................................... //
	const EnableJob = async (id) => {
		const data = {
			sessionId: sessionId,
			jobId: id,
		};
		console.log("Enable Data==>", data)
		try {
			await axios.post("/JobAction/EnableJob", data).then((resData) => {

				toast.success(resData.data.message);
				getAlljobList();

			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.error(e.response.data.message);
			} else {
				toast.error(e.response.data.message);
			}
		}
	};

	//.................................. Enable Job End  ................................... //

	//.................................. Disable Job End  ................................... //


	const DisableJob = async (id) => {
		try {
			const response = await axios.post(`/JobAction/DisableJob`, {
				sessionId: sessionId,
				jobId: id,
			});
			console.log("disable", response);
			toast.success(response.data.message);
			getAlljobList();

		} catch (error) {
			console.error("Error unsaving job:", error);
			toast.error(error.response?.data?.message || "An error occurred.");
		} finally {
			// setLoading(false);
		}
	};

	//.................................. Disable Job End  ................................... //

	const userUID = localStorage.getItem("userUID");

	// ...............................All Job List Start.......................................
	const [jobList, setjobList] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalRows, setTotalRows] = useState(1);

	// Search Filter.......
	const [search, setSearch] = useState("");
	const [filteredJobs, setFilteredJobs] = useState([]); // Store filtered jobs

	// ......................................... Search Filter 	  
	useEffect(() => {
		// Check if jobList is available and contains 'title' key
		const filteredData = jobList.filter((job) =>
			job?.title?.toLowerCase().includes(search.toLowerCase()) // Ensure 'title' exists
		);
		setFilteredJobs(filteredData);
	}, [search, jobList]);
	// ......................................... Search Filter	  


	// const getAlljobList = (page) => {
	// 	// setIsLoading(true); // Start loading
	// 	try {
	// 		const data = {
	// 			sessionId: sessionId,
	// 			pageNumber: page,
	// 			pageSize: 5,
	// 		};

	// 		axios
	// 			.post(`/Job/GetAllOwnedJobs`, data)
	// 			.then((response) => {
	// 				const res = response.data.responseData.jobsList || {};
	// 				console.log("joblist",res);	
	// 				setTotalRows(response.data.responseData.paging.allDataCount || 1); // Set the total number of rows
	// 				// const filteredJobs = res.filter((job) => !job.isDeleted);
	// 				setjobList(res);
	// 				setIsLoading(false)
	// 		    //    setIsError(true);


	// 			})
	// 			.catch((err) => {
	// 				console.error("Error fetching jobs:", err);
	// 			});
	// 	} catch (error) {
	// 		console.error("Unexpected error:", error);
	// 		// setIsError(true);
	// 	}
	// };


	// const getAlljobList = (page) => {
	// 	setIsLoading(true); // Start loading
	// 	try {
	// 		const data = {
	// 			sessionId: sessionId,
	// 			pageNumber: page,
	// 			pageSize: 34,
	// 		};

	// 	 	axios.post(`/Job/GetAllOwnedJobs`, data)
	// 		.then((response) => {
	// 			const res = response.data.responseData || {};
	// 			console.log("Full API Response:", res);

	// 			if (res?.jobsList && Array.isArray(res.jobsList)) {
	// 				console.log("Before Filtering:", res.jobsList); // Log before filtering

	//         // Apply the filter
	//         const filteredJobs = res.jobsList.filter(job => !job.isDeleted);

	//         console.log("After Filtering:", filteredJobs); // Log after filtering

	//         setjobList(filteredJobs);

	//         setTotalRows(filteredJobs.length);
	// 		console.log("pages", filteredJobs.length);

	//         // setTotalRows(res.paging.allDataCount || filteredJobs.length);

	// 		} else {
	// 			setjobList([]); 
	// 			setTotalRows(0);
	// 		}

	//        setIsLoading(false);
	// 		})
	// 		.catch((err) => {
	// 			console.error("Error fetching jobs:", err);
	// 			setIsLoading(false);
	// 		});

	// 	} catch (error) {
	// 		console.error("Unexpected error:", error);
	// 		setIsLoading(false);
	// 	}
	// };

	const getAlljobList = (page) => {
		// setIsLoading(true); // Start loading

		try {
			const data = {
				sessionId: sessionId,
				pageNumber: page,
				pageSize: 10,
			};

			axios
				.post(`/Job/GetAllOwnedJobs`, data)
				.then((response) => {
					const res = response.data.responseData.jobsList || [];
					console.log("joblist", res);
					// Apply the filter
					// const filteredJobs = res.filter(job => !job.isDeleted);
					// console.log("After Filtering:", filteredJobs); // Log after filtering
					// setjobList(filteredJobs);

					// setTotalRows(filteredJobs.length);
					// console.log("pages", filteredJobs.length);


					setTotalRows(response.data.responseData.paging.allDataCount || 1);
					setjobList(res);

					setIsError(res.length === 0); // If no jobs, set error state
					setIsLoading(false);
				})
				.catch((err) => {
					console.error("Error fetching jobs:", err);
					setIsError(true); // Handle error state
					setIsLoading(false);
					if (err.response && err.response.status === 409) {
						// toast.error(err.response.data.message);
						console.error("Unexpected error:", err);
						setUnAuthorizeError(err.response.data.message)
						handleunauthModal()
					} else {
						console.error("Unexpected error:", err);

					}
				});
		} catch (error) {
			console.error("Unexpected error:", error);
			setIsError(true);
			setIsLoading(false);

		}
	};


	useEffect(() => {
		getAlljobList(currentPage);
	}, [currentPage]);



	const [unauthModal, setUnauthModal] = useState(false);
	const handleunauthModal = () => setUnauthModal(true);
	const handlecloseunauthModal = () => setUnauthModal(false);


	// ...............................All Jobs List End.......................................

	const columns = [
		{
			name: "Details",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) =>
				<div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
					<div className="job-img text-center mt-2">
						<img
							src={row.compImage}
							alt="User"
							style={{ width: "50px", height: "50px", borderRadius: "50%" }}
						/>
					</div>
					<div className="text-center mb-2">

						<div className=" jobinfo f-600 "

						>
							{row.title}
						</div>
						<div className="">
							{moment(row.creationTime).format("DD MMM YYYY hh:mm:ss A")}
						</div>
					</div>
				</div>


			,
		},
		{
			name: "Company",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) =>
				UserType === "Company" ? row.compName : row?.associateCompanyShortInfo?.compName
		},
		{
			name: "City",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => row.cityName,
		},
		{
			name: " Designation",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => row.designationName,
		},
		// {
		// 	name: "CreationTime",
		// 	center: true,
		// 	sortable: true,
		// 	minWidth: "200px",
		// 	selector: (row) => <>
		// 		{moment
		// 			.utc(row.creationTime)
		// 			.local()
		// 			.format("DD MMM YYYY-hh : mm A")
		// 			}
		// 	</>,
		// },
		{
			name: "Action",
			center: true,
			minWidth: "200px",
			cell: (row) => (
				<>
					{row.isDeleted === true ? (<>
						<div className="job-footer-left">
							<ul className="red" style={{ margin: 0, padding: 0 }}>
								<li>
									Deleted
								</li>
							</ul>
						</div>
					</>) : (
						<>
							<Link to={`/job/Update/${row.jobId}`}>
								<EditSharpIcon
									style={{ cursor: "pointer", color: "black" }}
									className="joblist-eye-icon Dark-icon-color"
								/>
							</Link>
							<Link to={`/job/${row.jobId}`}>
								<VisibilitySharpIcon
									style={{ cursor: "pointer", color: "black" }}
									className="ms-2 joblist-eye-icon Dark-icon-color"
								/>
							</Link>

							<Dropdown className="view-job-dropdown">
								<Dropdown.Toggle as="span" className="icon-togg">
									<MoreHorizSharpIcon className="ms-2" />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										href="#"
										onClick={() => {
											setShowCloneFolder(!showCloneFolder);
											setCloneId(row.jobId);
										}}
									>
										<FileCopyIcon
											style={{ cursor: "pointer" }}
											className="material-symbols-sharp joblist-eye-icon me-2 mt-0"
										/>
										Clone Job
									</Dropdown.Item>
									<Dropdown.Item
										href="#"
										onClick={() => {
											handleShowModal();
											setJobId(row.jobId);
										}}
									>
										<DeleteOutlineSharpIcon
											style={{ cursor: "pointer" }}
											className="material-symbols-sharp joblist-eye-icon me-2 mt-0"
										/>
										Delete
									</Dropdown.Item>

									{row.status === 1 ? (
										<Dropdown.Item
											href="#"
											onClick={() => {
												DisableJob(row.jobId);
												// setJobId(row.jobId);
											}}
										>
											<BlockSharpIcon
												style={{ cursor: "pointer" }}
												className="material-symbols-sharp joblist-eye-icon me-2 mt-0"
											/>
											Disable
										</Dropdown.Item>
									) : (
										<Dropdown.Item
											href="#"
											onClick={() => {
												EnableJob(row.jobId);
												//setJobId(row.jobId);
											}}
										>
											<CheckCircleOutlineSharpIcon
												style={{ cursor: "pointer" }}
												className="material-symbols-sharp joblist-eye-icon me-2"
											/>
											Enable
										</Dropdown.Item>
									)}
								</Dropdown.Menu>
							</Dropdown>
						</>
					)}
				</>
			),
		},
	];


	// Search Filter Function Start.......
	useEffect(() => {
		const filteredData = jobList.filter((job) =>
			job.title.toLowerCase().includes(search.toLowerCase()) // Adjust 'title' as per job data
		);
		setFilteredJobs(filteredData);
	}, [search, jobList]); // Run effect when search or jobList changes

	return (
		<>
			<section className="pricing-section-three container jobapplication view-job-style view-style-mobile">
				<div className="row">
					<div className="mb-1 col-6">
						<h6 className="orange-title">
							<span className="orange-box me-2"></span>
							Jobs List
						</h6>
					</div>
					<div className="mb-1 col-6 text-start"></div>
				</div>
				<div className="container st3">
					<div className="row">
						<div className="col-lg-12">
							<div class="wd-findjob-filer">
								<div className="col-4 form-group-1 ps-1 khojSearch d-flex align-items-center mb-2">
									<SearchOutlined className="searchIcon" />
									<input
										type="text"
										className="input-filter-search"
										placeholder="Search"
										value={search}
										onChange={(e) => setSearch(e.target.value)}
									/>
								</div>
							</div>
							{isLoading ? (
								<div className="row mt-2">
									<div className="col-md-12">
										<ShimmerDiv mode="light" height={100} width={'100%'} />
									</div>
									<div className="col-md-12 mt-2">
										<ShimmerDiv mode="light" height={100} width={'100%'} />
									</div>
									<div className="col-md-12 mt-2">
										<ShimmerDiv mode="light" height={100} width={'100%'} />
									</div>
									<div className="col-md-12 mt-2">
										<ShimmerDiv mode="light" height={100} width={'100%'} />
									</div>
								</div>
							)
								: isError || jobList.length === 0 ? (
									<div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
										{/* <img src='/' alt="404 Not Found" width={200} /> */}
										<img src={error} alt="404 Not Found" width={300} />

									</div>
								)
									: (
										<div className="scroll-react-dataTable">

											<div className="react-dataTable react-table-colorclass">

												<DataTable
													noHeader
													pagination
													columns={columns}
													// data={jobList} // Pass the candidate list to the 
													data={filteredJobs} // Use filtered list
													progressPending={isLoading} // Show a loader when fetching data
													paginationServer // Enable server-side pagination
													paginationPerPage={10} // Number of rows per page
													paginationTotalRows={totalRows} // Total rows for calculating pages
													paginationDefaultPage={currentPage}
													paginationRowsPerPageOptions={[]}
													onChangePage={(page) => {
														setCurrentPage(page); // Update the current page
													}}
													sortIcon={<ChevronDown size={10} />} // Sorting icon
													className="react-dataTable" // Custom class for styling
												/>
											</div>
										</div>
									)}
						</div>
					</div>
				</div>
			</section>

			{/*...... Delete Education modal  Start................*/}

			<Modal show={showCloneFolder} onHide={handleCloneFolderClose} centered>
				<Modal.Header>
					<Modal.Title> Clone Job</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleCloneFolderClose}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Do you want to Clone this Job ?</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button onClick={CloneFolder} className="btn btn-danger me-2">
						Confirm
					</button>
					<button
						onClick={handleCloneFolderClose}
						className="btn btn-secondary"
					>
						Cancel
					</button>
				</Modal.Footer>
			</Modal>
			{/*...... Delete Education modal  End.................*/}
			{/*......  CloneJob modal  End*/}

			{/* .......................Delete modal start....................  */}
			<Modal show={showModal} onHide={handleCloseModal} centered>
				<Modal.Header>
					<Modal.Title>Confirm delete</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to delete this Job</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button onClick={handleConfirmDelete} className="btn btn-danger me-2">
						Confirm
					</button>
				</Modal.Footer>
			</Modal>
			{/* .......................Delete modal end......................  */}


			{/* ...............UnAuthorize modal............  */}
			{unAuthorizeError ? (
				<Modal show={unauthModal} centered>
					<Modal.Header>
						<Modal.Title>Unauthorize session expired</Modal.Title>
					</Modal.Header>
					<Modal.Body className="settings">
						<div className=" mb-3">
							<p>{unAuthorizeError}</p>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Link
							className="pointer"
							to="/Login"
							onClick={() => {
								localStorage.removeItem("token"); // Remove authentication token
								sessionStorage.removeItem("sessionId"); // Also clear from session storage if used
								localStorage.removeItem("Module");
							}}
						>
							<button className="btn btn-danger ">Login</button>
						</Link>
						{/* <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Login</button>  */}

					</Modal.Footer>

				</Modal>
			) : (
				""
			)}
		</>
	);
};

export default JobList;
